import {Action} from "../actions/uploadingImagesProgressActions";
import {UploadProgressingImagesDto} from "../../dtos";
import {ActionType} from '../actionTypes';

const initialState = {
    isOpen: false,
    current: 0,
    failCount: 0,
    processingFinished: true,
    successCount: 0,
    total: 0,
    titlePopup: ``,
    notUploadedImages: null,
    severityLevel: "OK",
    isUploadingFilesToSystem: false,
    isUploadingFilesToSystemFinished: false
}

export const uploadingImagesProgressReducer = (state: UploadProgressingImagesDto = initialState, action: Action): UploadProgressingImagesDto => {
    switch (action.type) {
        case ActionType.UPLOAD_IMAGES_PROGRESSBAR_POPUP_START:
            return {
                ...initialState,
                titlePopup: action?.payload.title || "",
                processingFinished: false,
                isUploadingFilesToSystem: false,
                isOpen: true
            };
        case ActionType.UPLOAD_IMAGES_PROGRESSBAR_POPUP_ERROR:
            return {
                ...initialState,
            };

        case ActionType.UPLOAD_IMAGES_PROGRESSBAR_POPUP_CHANGE:
            return {
                ...state,
                ...action.payload,
                isOpen: action.payload.isOpen || true,
                notUploadedImages:
                    state.notUploadedImages && action.payload.notUploadedImages
                        ? [...state.notUploadedImages, ...action.payload.notUploadedImages]
                        : action.payload.notUploadedImages
                            ? [...action.payload.notUploadedImages]
                            : state.notUploadedImages
                                ? [...state.notUploadedImages]
                                : null
            };

        case ActionType.UPLOAD_IMAGES_PROGRESSBAR_POPUP_CLOSE:
            return {
                ...state,
                isOpen: false
            };
        //delete only image from page
        default:
            return state;
    }

}